import { Button, Input } from "@material-tailwind/react";
import PaginationCustom from "../molecules/PaginationCustom";

const QuickSearchAndResult = ({
  searchKeyword,
  onSearchKeywordChange,
  onSearch,
  searchResults,
  onAddItem,
  placeholder = "Search by name",
  title = "Search Existing Items",
  resultTitle = "Search Results",
  renderItem = (item) => item.name,
  maxHeight = "200px",
  // Pagination props
  currentPage = 1,
  pageSize = 10,
  totalItems = 0,
  onPageChange,
  loading = false
}) => {
  return (
    <>
      {/* Search input */}
      <div className="mb-3">
        <div className="mb-2 font-medium text-gray-700">{title}</div>
        <div className="flex gap-2">
          <Input
            placeholder={placeholder}
            value={searchKeyword || ''}
            onChange={(e) => onSearchKeywordChange(e.target.value)}
            className="flex-1"
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                onSearch();
              }
            }}
          />
          <Button
            onClick={onSearch}
            className="px-4"
          >
            Search
          </Button>
        </div>
      </div>
      
      {/* Search results */}
      {searchResults.length > 0 && (
        <div className="mb-3">
          {/* <div className="mb-2 font-medium text-gray-700">{resultTitle} ({searchResults.length})</div>
           */}

           {/* Pagination */}
           <PaginationCustom
              currentPage={currentPage}
              pageSize={pageSize}
              totalItems={totalItems}
              onPageChange={onPageChange}
              showPageSize={false}
              loading={loading}
            />
          <div className={`max-h-[${maxHeight}] overflow-y-auto`}> 
            {searchResults.map(item => (
              <div 
                key={item._id}
                className="flex items-center justify-between p-2 mb-2 bg-white border border-gray-200 rounded hover:bg-blue-50"
              >
                <div>{renderItem(item)}</div>
                <Button
                  size="sm"
                  onClick={() => onAddItem(item)}
                >
                  Add
                </Button>
              </div>
            ))}
          </div>
          
          
        </div>
      )}
      {/* Display if no search results */}
      {!loading && searchResults.length === 0 && searchKeyword && (
        <div className="mb-3">
          <div className="text-gray-500">No results found</div>
        </div>
      )}
    </>
  );
};

export default QuickSearchAndResult;
